import { useMutation } from 'react-query';

import { axios } from '@/lib/axios';

type AddAdditionalInformation = {
  internalClientReference: string;
  containsEmptyPackages: boolean;
  vehicleNationality: string;
};

type UpdateCrossingRequestedDateType = {
  data: AddAdditionalInformation;
  folderTypologyId: string;
  folderId: string;
};

const addAdditionalInformationToFolderAsync = ({ folderTypologyId, folderId, data }: UpdateCrossingRequestedDateType) =>
  axios.put(`/folder-typologies/${folderTypologyId}/folders/${folderId}/additional-information`, data);

export const useAddAdditionalInformationToFolderAsync = () =>
  useMutation({
    mutationFn: addAdditionalInformationToFolderAsync,
  });
